"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SubItemText = exports.SubItemContainer = exports.OptionsDiv = exports.MultiItemToggle = exports.MultiItemDiv = exports.MobileHeaderDiv = exports.MobileHeader = exports.LinkContainer = exports.Header = exports.FilterText = exports.FilterBody = exports.DividerLine = exports.CreditCardFilter = exports.ContentWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _divider = _interopRequireDefault(require("./divider"));

var _jsxRuntime = require("react/jsx-runtime");

var Filter = (0, _styledComponents["default"])(_baseReactComponents.StandardCard).withConfig({
  displayName: "Filter",
  componentId: "sc-6vmbod-0"
})(["padding:0 0 16px 0;@media (", "){padding:0 0 40px 0;position:sticky;}"], _baseReactComponents.theme.forLargerThanPhone);

var MobileHeaderDiv = _styledComponents["default"].div.withConfig({
  displayName: "MobileHeaderDiv",
  componentId: "sc-6vmbod-1"
})(["display:grid;grid-template-columns:1fr min-content;width:100%;& > ", "{color:", ";margin:16px 16px 0 0;transform:", ";}@media (", "){display:none;}"], _baseReactComponents.Icon, _baseReactComponents.theme.neutral400, function (_ref) {
  var shouldShowFilter = _ref.shouldShowFilter;
  return !shouldShowFilter && 'rotate(180deg)';
}, _baseReactComponents.theme.forLargerThanPhone);

exports.MobileHeaderDiv = MobileHeaderDiv;
var MobileHeader = (0, _styledComponents["default"])(_baseReactComponents.StandardCard.Header).withConfig({
  displayName: "MobileHeader",
  componentId: "sc-6vmbod-2"
})(["padding:16px 0 0 16px;display:block;"]);
exports.MobileHeader = MobileHeader;
var Header = (0, _styledComponents["default"])(_baseReactComponents.StandardCard.Header).withConfig({
  displayName: "Header",
  componentId: "sc-6vmbod-3"
})(["display:none;@media (", "){padding:16px 0 0 16px;display:block;}"], _baseReactComponents.theme.forLargerThanPhone);
exports.Header = Header;

var FilterBody = _styledComponents["default"].div.withConfig({
  displayName: "FilterBody",
  componentId: "sc-6vmbod-4"
})(["display:", ";@media (", "){display:block;}"], function (_ref2) {
  var shouldShowFilter = _ref2.shouldShowFilter;
  return shouldShowFilter ? 'block' : 'none';
}, _baseReactComponents.theme.forLargerThanPhone);

exports.FilterBody = FilterBody;

var LinkContainer = _styledComponents["default"].div.withConfig({
  displayName: "LinkContainer",
  componentId: "sc-6vmbod-5"
})(["cursor:pointer;"]);

exports.LinkContainer = LinkContainer;
var FilterText = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "FilterText",
  componentId: "sc-6vmbod-6"
})(["padding:16px 8px;"]);
exports.FilterText = FilterText;

var MultiItemDiv = _styledComponents["default"].div.withConfig({
  displayName: "MultiItemDiv",
  componentId: "sc-6vmbod-7"
})(["display:flex;justify-content:space-between;width:100%;align-items:center;flex-wrap:wrap;cursor:pointer;background:", ";margin-top:", ";padding-top:", ";"], function (_ref3) {
  var theme = _ref3.theme,
      isOpen = _ref3.isOpen;
  return isOpen ? theme.neutral100 : 'white';
}, function (_ref4) {
  var isOpen = _ref4.isOpen;
  return isOpen && '-8px';
}, function (_ref5) {
  var isOpen = _ref5.isOpen;
  return isOpen && '8px';
});

exports.MultiItemDiv = MultiItemDiv;

var MultiItemToggle = _styledComponents["default"].div.withConfig({
  displayName: "MultiItemToggle",
  componentId: "sc-6vmbod-8"
})(["display:grid;grid-template-columns:4px 1fr min-content;width:100%;align-items:center;margin-left:16px;::before{content:' ';background:", ";width:4px;height:24px;border-radius:8px;}& > ", "{color:", ";margin:16px;transform:", ";}"], function (_ref6) {
  var theme = _ref6.theme,
      isActive = _ref6.isActive,
      isOpen = _ref6.isOpen;
  return isActive && !isOpen ? theme.azure : theme.transparent;
}, _baseReactComponents.Icon, _baseReactComponents.theme.neutral400, function (_ref7) {
  var shouldShowDropdown = _ref7.shouldShowDropdown;
  return !shouldShowDropdown && 'rotate(180deg)';
});

exports.MultiItemToggle = MultiItemToggle;
var SubItemText = (0, _styledComponents["default"])(_baseReactComponents.Copy).attrs(function () {
  return {
    size: 'sm'
  };
}).withConfig({
  displayName: "SubItemText",
  componentId: "sc-6vmbod-9"
})(["padding:8px 0 8px 8px;"]);
exports.SubItemText = SubItemText;
var DividerLine = (0, _styledComponents["default"])(_divider["default"]).withConfig({
  displayName: "DividerLine",
  componentId: "sc-6vmbod-10"
})(["margin:0 16px;"]);
exports.DividerLine = DividerLine;

var SubItemContainer = _styledComponents["default"].div.withConfig({
  displayName: "SubItemContainer",
  componentId: "sc-6vmbod-11"
})(["display:flex;align-items:center;cursor:pointer;margin-left:32px;::before{content:' ';background:", ";width:4px;height:16px;border-radius:8px;}"], function (_ref8) {
  var theme = _ref8.theme,
      isActive = _ref8.isActive;
  return isActive ? theme.azure : theme.transparent;
});

exports.SubItemContainer = SubItemContainer;

var ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ContentWrapper",
  componentId: "sc-6vmbod-12"
})(["margin-left:16px;display:flex;align-items:center;::before{content:' ';background:", ";width:4px;height:24px;border-radius:8px;}"], function (_ref9) {
  var theme = _ref9.theme,
      isActive = _ref9.isActive;
  return isActive ? theme.azure : theme.transparent;
});

exports.ContentWrapper = ContentWrapper;

var OptionsDiv = _styledComponents["default"].div.withConfig({
  displayName: "OptionsDiv",
  componentId: "sc-6vmbod-13"
})(["width:100%;padding-bottom:16px;"]);

exports.OptionsDiv = OptionsDiv;

var CreditCardFilter = function CreditCardFilter(_ref10) {
  var _ref10$creditCardFilt = _ref10.creditCardFilters,
      creditCardFilters = _ref10$creditCardFilt === void 0 ? [] : _ref10$creditCardFilt,
      _ref10$onFilterClick = _ref10.onFilterClick,
      onFilterClick = _ref10$onFilterClick === void 0 ? function () {} : _ref10$onFilterClick,
      _ref10$onSelectCatego = _ref10.onSelectCategory,
      onSelectCategory = _ref10$onSelectCatego === void 0 ? function () {} : _ref10$onSelectCatego,
      _ref10$onToggle = _ref10.onToggle,
      onToggle = _ref10$onToggle === void 0 ? function () {} : _ref10$onToggle,
      _ref10$activeFilter = _ref10.activeFilter,
      activeFilter = _ref10$activeFilter === void 0 ? '' : _ref10$activeFilter,
      _ref10$activeFilterOp = _ref10.activeFilterOption,
      activeFilterOption = _ref10$activeFilterOp === void 0 ? '' : _ref10$activeFilterOp,
      _ref10$activeCategory = _ref10.activeCategory,
      activeCategory = _ref10$activeCategory === void 0 ? '' : _ref10$activeCategory,
      _ref10$isExpanded = _ref10.isExpanded,
      isExpanded = _ref10$isExpanded === void 0 ? false : _ref10$isExpanded,
      _ref10$header = _ref10.header,
      header = _ref10$header === void 0 ? 'See credit cards best for' : _ref10$header,
      collapsedHeader = _ref10.collapsedHeader,
      className = _ref10.className;

  var handleToggleMultiItemDropdown = function handleToggleMultiItemDropdown(filterCategory) {
    onSelectCategory(filterCategory);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Filter, {
    className: className,
    "data-testid": "creditcardfilter:filter-index:wrapper",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(MobileHeaderDiv, {
      shouldShowFilter: isExpanded,
      onClick: onToggle,
      "data-testid": "creditcardfilter:mobile_header_div",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(MobileHeader, {
        label: !isExpanded && collapsedHeader != null ? collapsedHeader : !isExpanded && (activeFilterOption || activeFilter) ? activeFilterOption || activeFilter : 'See credit cards best for'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
        name: "actions/carrot-up"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Header, {
      label: header,
      "data-testid": "creditcardfilter:filter-title"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(FilterBody, {
      shouldShowFilter: isExpanded,
      children: creditCardFilters.map(function (filter, index) {
        return filter.options.length <= 1 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(LinkContainer, {
          onClick: function onClick() {
            return onFilterClick(filter.name, '');
          },
          index: index,
          "data-testid": "creditcardfilter:link_container",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ContentWrapper, {
            isActive: activeFilter === filter.name,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(FilterText, {
              bold: true,
              children: filter.name
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DividerLine, {})]
        }, filter.name) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(MultiItemDiv, {
          isOpen: activeCategory === filter.name,
          "data-testid": "creditcardfilter:multi_item_div",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(MultiItemToggle, {
            "data-testid": "creditcardfilter:filter-toggle",
            shouldShowDropdown: activeCategory === filter.name,
            onClick: function onClick() {
              return handleToggleMultiItemDropdown(filter.name);
            },
            isActive: filter.options.find(function (option) {
              return activeFilterOption === option;
            }),
            isOpen: activeCategory === filter.name,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(FilterText, {
              bold: true,
              children: filter.name
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
              name: "actions/carrot-up"
            })]
          }), activeCategory === filter.name ? /*#__PURE__*/(0, _jsxRuntime.jsx)(OptionsDiv, {
            "data-testid": "creditcardfilter:options_div",
            children: filter.options.map(function (option) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(SubItemContainer, {
                onClick: function onClick() {
                  return onFilterClick(filter.name, option);
                },
                isActive: activeFilterOption === option,
                "data-testid": "creditcardfilter:filter-sub-item",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SubItemText, {
                  children: option
                })
              }, option);
            })
          }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(DividerLine, {})]
        }, index);
      })
    })]
  });
};

exports.CreditCardFilter = CreditCardFilter;

var _default = (0, _styledComponents["default"])(CreditCardFilter).withConfig({
  componentId: "sc-6vmbod-14"
})([""]);

exports["default"] = _default;
//# sourceMappingURL=index.js.map